/* eslint-disable camelcase */
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { parse } from 'query-string';
import { sessionKeys } from '../../../core/session';
import { retriveConnectIdTokenDetails, sendEvent } from '../../../core/api';
import { useAsyncAction } from '../../../commonComponents/Hooks';
import { ConnectIdTokenRequestModel } from '../../../models/be/transport/connectIdTokenRequestModel';
import Event, { ConnectIdResultModel } from '../../../models/be/Event';
import { EventTypes } from '../../../core/enums';
import Loading from '../../../commonComponents/Loading';

const ConnectIdResponse = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [, , performAsyncAction] = useAsyncAction(true);

	const queryParams = parse(location.search);
	const { code: connectIdAuthCode, state: connectIdQueryState, iss: connectIdIss, error } = queryParams;

	const workflowId = localStorage.getItem(sessionKeys.workflowId) ?? '';

	React.useEffect(() => {
		if (error) {
			navigate('/dashboard', {
				state: { errorMessage: "Something went wrong. Please try again. Verification wasn't completed." }
			});
		}
	}, [error]);

	React.useEffect(() => {
		performAsyncAction(async () => {
			if (!error) {
				const { ConnectIdAuthorisationServerId, ConnectIdState, ConnectIdNonce, ConnectIdCodeVerifier } = sessionKeys;

				const data: ConnectIdTokenRequestModel = {
					authorisationServerId: localStorage.getItem(ConnectIdAuthorisationServerId) ?? '',
					queryState: connectIdQueryState?.toString() ?? '',
					state: localStorage.getItem(ConnectIdState) ?? '',
					nonce: localStorage.getItem(ConnectIdNonce) ?? '',
					codeVerifier: localStorage.getItem(ConnectIdCodeVerifier) ?? '',
					iss: connectIdIss?.toString() ?? '',
					authCode: connectIdAuthCode?.toString() ?? ''
				};

				const tokenDetails = await retriveConnectIdTokenDetails(data);
				const {
					given_name,
					middle_name,
					family_name,
					birthdate,
					txn: referenceId,
					iss,
					token,
					providerName,
					errorMessage
				} = tokenDetails as ConnectIdTokenResponse;

				const event: Event = {
					type: EventTypes.ConnectIdVerificationCompleted,
					workflowId,
					connectIdResponse: {
						givenName: given_name,
						middleName: middle_name,
						familyName: family_name,
						birthDate: birthdate,
						referenceId,
						iss,
						token,
						providerName,
						error: errorMessage
					} as ConnectIdResultModel
				};

				await sendEvent(event);

				navigate('/dashboard', {
					state: errorMessage
						? { errorMessage: "Check failed, please try again. Verification wasn't completed." }
						: { workflowId }
				});
			}
		});
	}, []);

	return <Loading />;
};

export default ConnectIdResponse;

interface ConnectIdTokenResponse {
	sub: string;
	given_name: string;
	middle_name: string;
	family_name: string;
	birthdate: string;
	txn: string;
	iss: string;
	providerName: string;
	token: string;
	errorMessage: string;
}
